import { io } from "socket.io-client";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function createSocket() {
  return io(BACKEND_URL, {
    path: "/api/socket.io",
    transports: ["websocket", "polling"],
  });
}
